/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/10/22
 */

import {gql} from "urql";

export const UpdateEmployeeMutation = gql`
    mutation UpdateEmployee($id: String!,$data: EmployeeInput!) {
        updateEmployee(id: $id, data: $data) {
            id
            displayName
            company
            countryCode
            department
            division
            employeeId
            city
            firstName
            lastName
            location
            state
            timeZone
            tags
            phoneNumber
            personalTitle
            jobTitle
            emailAddress
            manager {
                id
                displayName
            }
            dateOfBirth
	        dateOfHire
            timeZone
            startTime
            endTime
            gsacOooEnabled
	        capacityModifier
	        properties
        }
    }
`;

export interface UpdateEmployeeResponse {
	updateEmployee: boolean
}

export interface EmployeeInput {
	startTime? :string
	endTime?: string
	dateOfBirth?: Date | null
	dateOfHire?: Date | null
	gsacOooEnabled?: boolean
	tags?: string[] | null
	capacityModifier?: number
}

export interface UpdateEmployeeVars {
	id: string
	data: EmployeeInput
}